// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-DocumentViewer-DocumentViewer-module__selectWrapper";
var _2 = "webpack-components-shared-DocumentViewer-DocumentViewer-module__wrapper";
export { _1 as "selectWrapper", _2 as "wrapper" }
